import React, { useEffect, useState } from 'react'
import './PlusMinus.scss'

const PlusMinus = ({ onChange, index, defultValue }) => {
  const [value, setValue] = useState({ minus: false, plus: false })

  useEffect(() => {
    if (value?.minus || value?.plus) {
      onChange(value, index)
    }
  }, [value])

  return (
    <div className="plus-minus-holder">
      <div
        className={`plus-holder ${(value?.plus || defultValue?.plus) && 'active'}`}
        onClick={() => setValue({ minus: false, plus: true })}
      >
        <div className="plus">
          <i className="fa-solid fa-plus icon" style={{ fontSize: '0.95em' }}></i>
        </div>
      </div>
      <div
        className={`minus-holder ${(value?.minus || defultValue?.minus) && 'active'}`}
        onClick={() => setValue({ minus: true, plus: false })}
      >
        <div className="minus">
          <i className="fa-solid fa-minus icon" style={{ fontSize: '0.95em' }}></i>
        </div>
      </div>
    </div>
  )
}

export default PlusMinus
